import { API } from './axios-config'

export default {
	get: function (params, callback, error) {
		console.debug('Get Devices', params)

		API.get('v1/device', params)
			.then(response => {
				console.debug(response)

				var areDataValid = false

				if (response.data) {
					areDataValid = true

					callback(response.data)
				}

				if (!areDataValid) {
					error(e)
				}
			})
			.catch(e => {
				console.debug(e)

				error(e)
			})
	},

	addMultiple: function (postParams, callback, error) {
		console.debug('addMultiple', postParams)

		API.post('v1/device/bulk', postParams)
			.then(response => {
				console.debug(response)

				callback()
			})
			.catch(e => {
				console.debug(e)

				error(e)
			})
	},

	addMultipleViaRange: function (postParams, callback, error) {
		console.debug('addMultipleViaRange', postParams)

		API.post('v1/device/range', postParams)
			.then(response => {
				console.debug(response)

				callback()
			})
			.catch(e => {
				console.debug(e)

				error(e)
			})
	},

	deleteMultiple: function (params, callback, error) {
		console.debug('deleteMultiple', params)

		API.delete('v1/device/bulk', params)
			.then(response => {
				console.debug(response)

				callback()
			})
			.catch(e => {
				console.debug(e)

				error(e)
			})
	},
}
